// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_AcumularDadosInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /fechamentos/acumular_dados/{id}
 *
 * Accumulates running totals into a fechamento. No body required — id is a URL path parameter.
 */
import { registerContract } from './validate'

export interface Fechamentos_AcumularDadosInput {}

registerContract('Fechamentos_AcumularDadosInput', {})
